module.exports = __webpack_public_path__ + "static/media/notFoundCharacterVersar.89464efd.svg";